import styled from 'styled-components';
import { crTheme } from '@comicrelief/component-library';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  text-decoration: none;
  margin-top: 30px;
`;

const ArrowIcon = styled.div`
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  transition: left 0.15s ease-in-out, opacity 0.15s ease-in-out;
  width: 16px;
  height: 100%;
  display: flex;
  align-items: center;

  svg {
    width: 100%;
    height: 100%;
    stroke-width: 3;
  }

  @media ${crTheme.allBreakpoints('M')} {
    display: block;
  }
`;

const StyledButton = styled.button`
  position: relative;
  background: transparent;
  border: none;
  display: flex;
  color: ${crTheme.color('grey_4')};

  p {
    margin-left: 0;
    transition: margin-left 0.15s ease-in-out;
  }
  &:hover, &:active, &:focus {
    color: ${crTheme.color('grey_dark')};
    /* animate the arrow */
    ${ArrowIcon} {
      opacity: 1;
      left: -10px;
    }
    /* shift text to the right */
    p {
      margin-left: 5px;
    }
  }
`;

export { Wrapper, ArrowIcon, StyledButton };
